export const sd = {
    spiel: [
      11,12,13,14,21,22,23,24,31,32,33,34,41,42,43,44,51,52,
      53,54,61,62,63,64,71,72,73,74,81,82,83,84,91,92,93,94,
      11,12,13,14,21,22,23,24,31,32,33,34,41,42,43,44,51,52,
      53,54,61,62,63,64,71,72,73,74,81,82,83,84,91,92,93,94,
      11,12,13,14,21,22,23,24,31,32,33,34,41,42,43,44,51,52,
      53,54,61,62,63,64,71,72,73,74,81,82,83,84,91,92,93,94,
      11,12,13,14,21,22,23,24,31,32,33,34,41,42,43,44,51,52,
      53,54,61,62,63,64,71,72,73,74,81,82,83,84,91,92,93,94,
    ],
    positionen: [
      [7,1,0], [9,1,0], [11,1,0], [13,1,0], [15,1,0], 
      [2,2,0], [4,2,0], [18,2,0], [20,2,0], 
      [6,3,0], [8,3,0], [10,3,0], [12,3,0], [14,3,0], [16,3,0], 
      [2,4,0], [4,4,0], [18,4,0], [20,4,0], 
      [7,5,0], [9,5,0], [11,5,0], [13,5,0], [15,5,0], 
      [3,6,0], [5,6,0], [17,6,0], [19,6,0], 
      [1,7,0], [7,7,0], [9,7,0], [11,7,0], [13,7,0], [15,7,0], [21,7,0], 
      [3,8,0], [5,8,0], [17,8,0], [19,8,0], 
      [7,9,0], [9,9,0], [11,9,0], [13,9,0], [15,9,0], 
      [2,10,0], [4,10,0], [18,10,0], [20,10,0], 
      [6,11,0], [8,11,0], [10,11,0], [12,11,0], [14,11,0], [16,11,0], 
      [2,12,0], [4,12,0], [18,12,0], [20,12,0], 
      [7,13,0], [9,13,0], [11,13,0], [13,13,0], [15,13,0], 

      [8,1,1], [14,1,1], 
      [10,2,1], [12,2,1], 
      [3,3,1], [5,3,1], [7,3,1], [15,3,1], [17,3,1], [19,3,1], 
      [9,4,1], [11,4,1], [13,4,1], 
      [4,5,1], [6,5,1], [16,5,1], [18,5,1], 
      [8,6,1], [10,6,1], [12,6,1], [14,6,1], 
      [4,7,1], [6,7,1], [16,7,1], [18,7,1], 
      [8,8,1], [10,8,1], [12,8,1], [14,8,1], 
      [4,9,1], [6,9,1], [16,9,1], [18,9,1], 
      [9,10,1], [11,10,1], [13,10,1], 
      [3,11,1], [5,11,1], [7,11,1], [15,11,1], [17,11,1], [19,11,1], 
      [10,12,1], [12,12,1], 
      [8,13,1], [14,13,1], 

      [6,5,2], [8,5,2], [10,5,2], [12,5,2], [14,5,2], [16,5,2], 
      [5,7,2], [7,7,2], [9,7,2], [11,7,2], [13,7,2], [15,7,2], [17,7,2], 
      [6,9,2], [8,9,2], [10,9,2], [12,9,2], [14,9,2], [16,9,2], 

      [8,6,3], [10,6,3], [12,6,3], [14,6,3], 
      [6,7,3], [16,7,3], 
      [8,8,3], [10,8,3], [12,8,3], [14,8,3], 

      [9,7,4], [11,7,4], [13,7,4], 

      [10,7,5], [12,7,5], 

      [11,7,6], 
    ],
    index: [11,21,31,41,51,61,71,81,91,12,22,32,42,52,62,72,82,92,
            13,23,33,43,53,63,73,83,93,14,24,34,44,54,64,74,84,94],
    code: '0123456789abcdefghijklmnopqrstuvwxyz',
    stein: null,
    zuege: null,
    idx: 0,
		inPos(x,y,z) {
			return this.positionen.find(p => (p[0]===x && p[1]===y && p[2]===z));
		},
    gleich(s1, s2) {
      return s1 && s2 && s1.i === s2.i && s1.x === s2.x && s1.y === s2.y && s1.z === s2.z;
    },
    leer(s) {
      return s.i === 0;
    },
    steinFrei(feld, s) {
      if (s.z < 6 && [[-1,-1], [-1,0], [-1,1], [0,-1], [0,0], [0,1], [1,-1], [1,0], [1,1]].some(diff => {
        return s.y + diff[1] > 0 && s.x + diff[0] > 0 && feld[s.z + 1][s.y + diff[1]][s.x + diff[0]].i > 0;
      })) {
        return false;
      }
      return (
        ![[-2, -1],[-2, 0],[-2, 1]].some(diff => {
          return s.y + diff[1] > 0 && s.x + diff[0] > 0 && feld[s.z][s.y + diff[1]][s.x + diff[0]].i > 0;
        }) || 
        ![[2, -1],[2, 0],[2, 1]].some(diff => {
          return s.y + diff[1] > 0 && s.x + diff[0] > 0 && feld[s.z][s.y + diff[1]][s.x + diff[0]].i > 0;
        }) 
      );
    },
}